export default () => ({
  devices: [],
  pairinfo: null,
  stats: null
})



// WEBPACK FOOTER //
// ./src/store/modules/simulator/state.js